import React, { memo, useState, useCallback } from "react";
import { Text } from "@shopify/polaris";
import { ArrowDownIcon, ArrowUpIcon } from "@shopify/polaris-icons";

const FAQ_ITEMS = [
  {
    q: "Does the free shipping bar work with all Shopify themes?",
    a: "Yes. The bar uses a theme app embed, so it works with most Online Store 2.0 themes. If shoppers do not see it, enable the app embed in Theme editor and save.",
  },
  {
    q: "How do I show the bar on product or cart pages?",
    a: "Choose your placement when creating the bar. Step 2 of the setup guide opens the theme editor on the matching template (product, cart, or home) so you can add the app block.",
  },
  {
    q: "How do I make free shipping actually apply at checkout?",
    a: "This app displays a progress bar on your storefront — it does not create shipping discounts. In Shopify admin go to Settings → Shipping and delivery, add a price-based rate with a $0 cost when the order total meets your goal. Match the minimum order value to the goal you set in this app.",
  },
  {
    q: "Can I set a different free-shipping threshold?",
    a: "Yes. Edit your bar from Settings and change the goal amount and messages. Use {remaining} in messages to show how much is left for free shipping.",
  },
  {
    q: "Why is the bar not visible on my store?",
    a: "Usually the theme app embed is off, the bar is not saved, or the placement does not match the page you are viewing. Complete setup guide step 2 and refresh theme status.",
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = useCallback((idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  }, []);

  return (
    <div className="age-faq-section">
      <Text as="h2" variant="headingLg">
        Frequently asked questions
      </Text>

      <div className="age-faq-list">
        {FAQ_ITEMS.map((item, idx) => {
          const open = openIndex === idx;
          return (
            <div key={item.q} className={`age-faq-item${open ? " age-faq-item--open" : ""}`}>
              <button
                type="button"
                className="age-faq-item__btn"
                onClick={() => toggle(idx)}
                aria-expanded={open}
              >
                <Text as="span" variant="bodyMd" fontWeight="semibold">
                  {item.q}
                </Text>
                <span className="age-faq-item__icon" aria-hidden>
                  {open ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </span>
              </button>
              {open ? (
                <div className="age-faq-item__answer">
                  <Text as="p" variant="bodyMd" tone="subdued">
                    {item.a}
                  </Text>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default memo(FaqSection);
